export default __webpack_public_path__ + "static/media/img-4.b1413592.jpg";